import SurveyTemplate from '@/models/SurveyTemplate';

const GET_SURVEY_TEMPLATES = 'get_survey_templates';
const GET_SURVEY_TEMPLATES_REQUEST = 'get_survey_templates_request';
const GET_SURVEY_TEMPLATES_SUCCESS = 'get_survey_templates_success';
const GET_SURVEY_TEMPLATES_ERROR = 'get_survey_templates_error';


export { GET_SURVEY_TEMPLATES };

export default {
    state: {
        templates: [],
        loading: false,
        templatesErrors: [],
        templatesMeta: {},
    },
    mutations: {
        [GET_SURVEY_TEMPLATES_REQUEST]: (state) => {
            state.templates = [];
            state.loading = true;
            state.templatesErrors = [];
            state.templatesMeta = {};
        },
        [GET_SURVEY_TEMPLATES_SUCCESS]: (state, { templates, meta }) => {
            state.templates = templates;
            state.loading = false;
            state.templatesErrors = [];
            state.templatesMeta = meta;
        },
        [GET_SURVEY_TEMPLATES_ERROR]: (state, { errors }) => {
            state.templates = [];
            state.loading = false;
            state.templatesErrors = errors;
            state.templatesMeta = {};
        },
    },
    actions: {
        [GET_SURVEY_TEMPLATES]: ({ commit, state }, { params = {} }) => {
            commit(GET_SURVEY_TEMPLATES_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.templatesMeta.current_page) {
                        params.page = state.templatesMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                SurveyTemplate.collection(params)
                    .then(({items, meta}) => {
                        const templates = items;
                        commit(GET_SURVEY_TEMPLATES_SUCCESS, { templates, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_SURVEY_TEMPLATES_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/survey-templates.js